import { render, staticRenderFns } from "./assetsTypeLabel.vue?vue&type=template&id=e63040cc&scoped=true&"
import script from "./assetsTypeLabel.vue?vue&type=script&lang=js&"
export * from "./assetsTypeLabel.vue?vue&type=script&lang=js&"
import style0 from "./assetsTypeLabel.vue?vue&type=style&index=0&id=e63040cc&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e63040cc",
  null
  
)

export default component.exports